import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import about from '@/components/about'
import HeadTab from '@/components/HeadTab'
import BomTab from '@/components/BomTab'
import obtain from '@/components/obtain'
import tutorial from '@/components/tutorial'
import conte from '@/components/conte'
import loancard from '@/components/loancard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },{
      path: '/about',
      name: 'about',
      component: about
    },{
      path: '/HeadTab',
      name: 'HeadTab',
      component: HeadTab
    },{
      path: '/BomTab',
      name: 'BomTab',
      component: BomTab
    },{
      path: '/obtain',
      name: 'obtain',
      component: obtain
    },{
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial
    },{
      path: '/conte',
      name: 'conte',
      component: conte
    },{
      path: '/loancard',
      name: 'loancard',
      component: loancard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js